import { type ApprovalConfig, TimeUnits } from "@doitintl/cmp-models";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useFormikContext } from "formik";

export const AutoRejectApproval = () => {
  const { values, errors, setFieldValue } = useFormikContext<ApprovalConfig>();
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            name="rejectApprovalAfterTime"
            checked={Boolean(values.rejectApprovalAfterTime)}
            onChange={(e) => {
              setFieldValue("rejectApprovalAfterTime", e.target.checked);
            }}
          />
        }
        label="Reject approval after certain time"
      />

      {values.rejectApprovalAfterTime && (
        <Stack
          spacing={2}
          direction={"row"}
          sx={{
            pt: 1,
          }}
        >
          <TextField
            fullWidth
            name="rejectTimeValue"
            label="Number"
            type="number"
            value={values.rejectTimeValue}
            error={Boolean(errors.rejectTimeValue)}
            helperText={errors.rejectTimeValue}
            onChange={(e) => {
              setFieldValue("rejectTimeValue", parseInt(e.target.value));
            }}
            slotProps={{
              input: { inputProps: { min: 1 } },
            }}
          />
          <FormControl fullWidth size="small">
            <InputLabel error={Boolean(errors.rejectTimeUnit)}>Time unit</InputLabel>
            <Select
              name="rejectTimeUnit"
              label="Time unit"
              value={values.rejectTimeUnit || ""}
              error={Boolean(errors.rejectTimeUnit)}
              onChange={(e) => {
                setFieldValue("rejectTimeUnit", e.target.value as TimeUnits);
              }}
            >
              {Object.values(TimeUnits).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Select>
            {errors.rejectTimeUnit !== undefined && (
              <FormHelperText error={true}>{errors.rejectTimeUnit}</FormHelperText>
            )}
          </FormControl>
        </Stack>
      )}
    </>
  );
};
